import { HistoryData, HistoryResources } from './history'
import { FailedResponse } from './response'
import { ID } from '../types/UtilityTypes'

export enum NotificationType {
    HISTORY_CHANGE = 'App\\Notifications\\HistoryChange',
    SYSTEM_MESSAGE = 'App\\Notifications\\SystemMessage',
}

export enum MessageType {
    DEFAULT = 0,
    IMPORTANT = 10,
    WARNING = 20,
    ERROR = 30,
}

export const messageTypeToClass = (type: MessageType): string => 'MESSAGE_TYPE_' + MessageType[type]

export interface HistoryNotification {
    id: ID,
    kind: NotificationKind,
    created_at: string,
    read: boolean,
    type: NotificationType.HISTORY_CHANGE
    data: HistoryData,
}

export interface HistoryResourceNotification extends HistoryNotification {
    resources: HistoryResources,
}

export interface MessageNotification {
    id: ID,
    kind: NotificationKind,
    created_at: string,
    read: boolean,
    type: NotificationType.SYSTEM_MESSAGE
    data: {
        type: MessageType,
        subject: string,
        text: string,
        url: string,
    },
}

export type Notification = MessageNotification | HistoryNotification
export type PushNotification = MessageNotification | HistoryResourceNotification

export interface NotificationResponse {
    success: true,
    rows: {
        data: Notification[],
        resources: HistoryResources,
    },
    total: number,
}

export type NotificationFullResponse = NotificationResponse | FailedResponse

export type NotificationKind = 'system' | 'user'
export type NotificationOutbox = 0 | 1